import { AppThunk, AppDispatch } from '@app/store/store'
import { cmsSdk } from '@app/api/endpoints'

import { actions } from './slice'

export const getTherapists = (): AppThunk => async (dispatch: AppDispatch) => {
  dispatch(actions.requestFetchTherapists())

  try {
    const response = await cmsSdk.GetTherapists()
    dispatch(actions.successFetchTherapists(response))
  } catch (error) {
    dispatch(actions.errorFetchTherapists(error.errors?.[0]?.message))
  }
}

export const getTherapistsByCities = (citiesIds: string[]): AppThunk => async (dispatch: AppDispatch) => {
  dispatch(actions.requestFetchTherapists())

  try {
    const response = await cmsSdk.GetTherapistsByCity({ cityIds: [...citiesIds] })
    dispatch(actions.successFetchTherapists(response))
  } catch (error) {
    dispatch(actions.errorFetchTherapists(error.errors?.[0]?.message))
  }
}
